import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import type { NodeResult } from '../types';

interface CustomNodeProps {
  data: {
    label: string;
    nodeType: string;
    domain?: string;
    routeDescription?: string;
    color: string;
    active?: NodeResult | null;
    isRunning?: boolean;
  };
  selected?: boolean;
}

function CustomNode({ data, selected }: CustomNodeProps) {
  const { label, nodeType, color, active, isRunning } = data;

  let statusClass = '';
  if (isRunning && !active) {
    statusClass = 'running';
  } else if (active) {
    statusClass = `active-${active.status}`;
  }

  return (
    <div className={`custom-node ${statusClass} ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} />

      <div className="node-header">
        <div className="node-color-bar" style={{ backgroundColor: color }} />
        <div>
          <div className="node-label">{label}</div>
          <div className="node-type-badge">{nodeType}</div>
          {data.domain && <div className="node-domain">Domain: {data.domain}</div>}
          {data.routeDescription && <div className="node-route-description">{data.routeDescription}</div>}
        </div>
      </div>

      {active && (
        <div className="node-output-preview">
          {active.output.length > 120
            ? active.output.slice(0, 120) + '...'
            : active.output}
        </div>
      )}

      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}

export default memo(CustomNode);
